import PropTypes from "prop-types"
import { Box } from "@mui/material"

function Circle({ width = 12, height = 12, color = "success.main" }) {
  return (
    <Box
      component="span"
      sx={{
        bgcolor: color,
        width,
        height,
        borderRadius: "50%",
      }}
    />
  )
}

Circle.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default Circle
